import ListPemeliharaanAset from './ListPemeliharaanAset';

export default ListPemeliharaanAset;
